import { shallowReactive, ShallowReactive } from 'vue'
import { ShallowRef } from '@vue/reactivity'

export const createShallowReactive = <T>(
  sourceObject = {},
): ShallowReactive<{ [key: string]: ShallowRef<T> }> => {
  return shallowReactive<{ [key: string]: ShallowRef<T> }>(sourceObject)
}
